export const getItems = cart => {
    const regionalCases = cart.regionalCases || []
    const allShoppingCartProducts = regionalCases.map(
        regionalCase =>
            regionalCase.caseItems.map(
                item => item.shoppingCartProducts
            ).reduce(
                (prev, curr) => [...prev, ...curr], []
            )
    ).reduce(
        (prev, curr) => [...prev, ...curr], []
    )
    return allShoppingCartProducts
}